import * as React from 'react';
import { FeatureIcon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

/**
 *
 * These labels are dynamically generated:
 *   products.sunglasses.features.uvCategory
 *   products.sunglasses.features.polarized
 *   products.sunglasses.features.glazeable
 *
 */ const ProductDetailFeatures = ({ productFeatures , colorFeatureIcons ='orange' ,  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("ul", {
        className: "product-detail-features"
    }, productFeatures.map(({ type , iconName  })=>/*#__PURE__*/ React.createElement("li", {
            className: "product-detail-features__feature",
            key: type
        }, /*#__PURE__*/ React.createElement(FeatureIcon, {
            name: iconName,
            color: colorFeatureIcons,
            size: 38
        }), getLabel(`products.sunglasses.features.${type}`))
    ));
};

export { ProductDetailFeatures };
//# sourceMappingURL=ProductDetailFeatures.js.map
